import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { useOrganisation, useToastMessage, ToastVariant } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { Provider } from '~/Models/DTO/Provider.model';
import { IOrgStudios } from '~/ScreensOrganisation/OrganisationStudio/Studio.model';
import { providerDataHelper } from './helpers';

export const useRequestProviderCreate = () => {
  const { organisation } = useOrganisation();
  const { showToast } = useToastMessage();
  const { t } = useTranslation();

  const queryClient = useQueryClient();

  return useMutation<Provider, IErrorResponse, IOrgStudios>(
    async (studio: IOrgStudios) => {
      const response = await requestReactQuery<Provider>({
        url: PROVIDER_SERVICE_URLS.CREATE_PROVIDER,
        data: providerDataHelper(studio, organisation?.email, organisation?.id),
        config: { method: 'POST' },
      });
      queryClient.invalidateQueries(REQUEST_ACTIONS.USER_ROLES);

      return response;
    },
    {
      onError: () =>
        showToast('location_creation_failed', t('app.default.error'), ToastVariant.ERROR, true),
    },
  );
};
